export const scrollToTop = (data) => {
    console.log(data);
    const form = document.querySelectorAll('.error-message');
    const errors = [...form].filter((el) => el.innerText !== '');
    const y = errors[0].getBoundingClientRect().top + window.scrollY;

    window.scroll({
        top: y - 250,
        behavior: 'smooth',
    });
};
